/* eslint-disable */
export default {
  order: 1,
  header: [
    {
      category: 'Overview',
      item: [
        {
          title: '',
          list: [
            {
              name: 'What is EnOS',
              url: '/docs/enos/en/3.1.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS Advantages',
              url: '/docs/enos/en/3.1.0/overview/advantage.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/enos/en/3.1.0/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: 'Product Documentation',
      item: [
        {
          title: 'Application Building',
          list: [
            {
              name: 'Digital Twin Visualization',
              url: '/docs/dtv/en/3.1.0/overview.html'
            },
            {
              name: 'Unified Monitoring',
              url: '/docs/monitor/en/3.1.0/overview/monitor_overview.html'
            },
            {
              name: 'Reporting Tool',
              url: '/docs/reporting/en/3.1.0/overview.html'
            },
            {
              name: 'Alarm Management',
              url: '/docs/alarm-management/en/3.1.0/overview/about.html'
            },
            {
              name: 'Alert Engine',
              url: '/docs/alert/en/3.1.0/learn/alert_overview.html'
            },
            {
              name: 'Work Management',
              url: '/docs/wmt/en/3.1.0/about.html'
            },
            {
              name: 'Fleet Control',
              url: '/docs/control/en/3.1.0/overview.html'
            },
            {
              name: 'Notification Management ',
              url: '/docs/notification-mgmt/en/3.1.0/notification_center_overview.html'
            },
            {
              name: 'Application Portal',
              url: '/docs/app-portal/en/3.1.0/overview.html'
            },
            {
              name: 'Application Register',
              url: '/docs/app-development/en/3.1.0/app_management/overview.html'
            },
            {
              name: 'API Management',
              url: '/docs/apim/en/3.1.0/api_management_overview.html'
            }
          ]
        },
        {
          title: 'Data Management and Analytics',
          list: [
            {
              name: 'Data Subscription',
              url: '/docs/data-subscription/en/3.1.0/data_subscription_overview.html'
            },
            {
              name: 'Data Archiving',
              url: '/docs/data-archiving/en/3.1.0/archive_policy.html'
            },
            {
              name: 'Data Source Registration',
              url: '/docs/data-source-reg-app/en/3.1.0/datasource_overview.html'
            },
            {
              name: 'Model Management',
              url: '/docs/modelling-tool/en/3.1.0/overview/about.html'
            }
          ]
        },
        {
          title: 'Device Connectivity and Management',
          list: [
            {
              name: 'Device Connection',
              url: '/docs/device-connection/en/3.1.0/learn/message_flow.html'
            },
            {
              name: 'Device Management',
              url: '/docs/device-connection/en/3.1.0/learn/device_lifecycle_management.html'
            },
            {
              name: 'Data Quality',
              url: '/docs/data-quality/en/3.1.0/overview/about.html'
            },
            {
              name: 'Device Data Integration Service',
              url: '/docs/device-integration/en/3.1.0/learn/device_integration_overview.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: 'View all products',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/en/3.1.0'
      },
      showListInMobile: false
    },
    {
      category: 'Tutorials',
      item: [
        {
          title: 'Data Integration',
          list: [
            {
              name: 'Connecting a Simulated Device to EnOS Cloud',
              url: '/docs/device-connection/en/3.1.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'Connecting a Simulated Electricity Meter to EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/tutorial/connecting_edge.html'
            }
          ]
        },
        {
          title: 'Data Development',
          list: [
            {
              name: 'Assessing Data Quality of the Wind Turbine',
              url: '/docs/data-quality/en/3.1.0/tutorial.html'
            }
          ]
        },
        {
          title: 'Application Development',
          list: [
            {
              name: 'Creating Applications Using Common Building Blocks',
              url: '/docs/app-development/en/3.1.0/app_dev_workflow/index.html'
            },
            {
              name: 'Building a Smart Battery Dashboard',
              url: '/docs/dtv/en/3.1.0/tutorial/index.html'
            },
            {
              name: 'Building a Water Purification System Monitoring Page',
              url: '/docs/dtv/en/3.1.0/tutorial/monitor.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: 'View all tutorials',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/en/3.1.0/tutorial'
      },
      showListInMobile: false
    },
    {
      category: 'Resources',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/enos-apis/'
            },
            {
              name: 'SDKs and Tools',
              url: 'https://developer.enos-iot.com/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: [
    {
      category: 'Data Integration',
      item: [
        {
          name: 'Connecting a Simulated Device to EnOS Cloud',
          description: 'Estimated Time: 80 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/en/3.1.0/tutorial/connecting_device_simulated/index.html'
        },
        {
          name: 'Connecting a PC to EnOS Cloud',
          description: 'Estimated Time: 110 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/en/3.1.0/tutorial/connecting_pc/index.html'
        },
        {
          name: 'Connecting a Simulated Electricity Meter to EnOS Edge',
          description: 'Estimated Time: 40 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/enos-edge/en/3.1.0/tutorial/connecting_edge.html'
        }
      ]
    },
    {
      category: 'Data Development',
      item: [
        {
          name: 'Assessing Data Quality of the Wind Turbine',
          description: 'Estimated Time: 30 mins',
          image: 'assets/images/tutorial/quality_en.png',
          url: '/docs/data-quality/en/3.1.0/tutorial.html'
        }
      ]
    },
    {
      category: 'Application Development',
      item: [
        {
          name: 'Registering and Managing Applications',
          description: 'Estimated Time: 40 mins',
          image: 'assets/images/tutorial/app_en.png',
          url: '/docs/app-development/en/3.1.0/app_management/managing_apps.html'
        },
        {
          name: 'Creating Applications Using Industry Application Common Building Blocks',
          description: 'Estimated Time: 160 mins',
          image: 'assets/images/tutorial/cbb_app_en.png',
          url: '/docs/app-development/en/3.1.0/app_dev_workflow/index.html'
        },
        {
          name: 'Building a Smart Battery Dashboard',
          description: 'Estimated Time: 80 mins',
          image: 'assets/images/tutorial/battery_dashboard_en.png',
          url: '/docs/dtv/en/3.1.0/tutorial/index.html'
        },
        {
          name: 'Building a Water Purification System Monitoring Page',
          description: 'Estimated Time: 80 mins',
          image: 'assets/images/tutorial/water_monitoring_en.png',
          url: '/docs/dtv/en/3.1.0/tutorial/monitor.html'
        }
      ]
    }
  ]
};
